module.exports = __webpack_public_path__ + "static/team7-3289d776e9e0d7005c29bf55a9600f5c.jpg";